var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.html.type && _vm.html.elements ? _c('fragment', _vm._l(_vm.html.elements, function (el, idx) {
    var _ref;
    return _c('fragment', {
      key: idx
    }, [el.type === _vm.ElementTypes.ELEMENT ? _c('html-renderer', {
      key: (el + "-" + idx),
      style: el.attributes && el.attributes.style && (_ref = {}, _ref[el.attributes.style.split(':')[0]] = el.attributes.style.split(':')[1], _ref),
      attrs: {
        "htmlObject": el,
        "onClick": _vm.onClick,
        "onFocus": _vm.onFocus,
        "onFocusOut": _vm.onFocusOut,
        "getTextClass": _vm.getTextClass,
        "getTabIndex": _vm.getTabIndex,
        "isPickTheAnswer": _vm.isPickTheAnswer
      }
    }) : _vm._e()], 1);
  }), 1) : _vm.html.type === _vm.ElementTypes.ELEMENT ? _c(_vm.elementNameSelector(_vm.html.name), {
    tag: "component",
    staticClass: "topComponent"
  }, [_vm._l(_vm.html.elements, function (el) {
    var _ref2;
    return [el.type === _vm.ElementTypes.ELEMENT ? _c('html-renderer', {
      style: el.attributes && el.attributes.style && (_ref2 = {}, _ref2[el.attributes.style.split(':')[0]] = el.attributes.style.split(':')[1], _ref2),
      attrs: {
        "htmlObject": el,
        "onClick": _vm.onClick,
        "onFocus": _vm.onFocus,
        "onFocusOut": _vm.onFocusOut,
        "getTabIndex": _vm.getTabIndex,
        "getTextClass": _vm.getTextClass,
        "isPickTheAnswer": _vm.isPickTheAnswer
      }
    }) : [_vm.maybeContainsHighlightClass(el.index, el) || _vm.onClick !== undefined ? _c('span', {
      class: _vm.maybeHighlightClass(el.index, el),
      attrs: {
        "tabindex": _vm.getTabIndex(el.index, el),
        "id": el.type === _vm.ElementTypes.WORD ? ("word-" + (el.index)) : ("text-" + (el.index)),
        "role": !!_vm.maybeAriaPressed(el.index, el) ? 'checkbox' : 'none',
        "aria-pressed": _vm.maybeAriaPressed(el.index, el),
        "aria-checked": _vm.maybeAriaPressed(el.index, el) === 'true' ? true : false
      },
      on: {
        "click": function (e) {
          var _vm$onClick, _vm2;
          return (_vm$onClick = (_vm2 = _vm).onClick) === null || _vm$onClick === void 0 ? void 0 : _vm$onClick.call(_vm2, el.index);
        },
        "focus": function (e) {
          var _vm$onFocus, _vm3;
          return (_vm$onFocus = (_vm3 = _vm).onFocus) === null || _vm$onFocus === void 0 ? void 0 : _vm$onFocus.call(_vm3, el.index, e);
        },
        "focusout": function () {
          var _vm$onFocusOut, _vm4;
          return (_vm$onFocusOut = (_vm4 = _vm).onFocusOut) === null || _vm$onFocusOut === void 0 ? void 0 : _vm$onFocusOut.call(_vm4);
        }
      }
    }, [_vm._v(_vm._s(el.text))]) : [_vm._v(_vm._s(el.text))]]];
  })], 2) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }